import Bowser, { BROWSER_MAP, PLATFORMS_MAP } from "bowser";

export const checkIfDesktop = () => {
  const userAgent = window?.navigator?.userAgent;
  const browser = Bowser.getParser(userAgent);
  return browser.getPlatformType() === PLATFORMS_MAP.desktop;
};
